const changeByOptions = [
    -10,
    -1,
    1,
    10
];

export {changeByOptions};
